import { Sidebar, SidebarContent, SidebarFooter } from "@components/ui/sidebar";
import { useLocation, useParams } from "react-router-dom";
import { HeaderNav } from "./partials/HeaderNav";
import { MainNav } from "./partials/MainNav";
import { SearchesNav } from "./partials/SearchesNav";
import { TagsNav } from "./partials/TagsNav";
import { FooterNav } from "./partials/FooterNav";

export default function MainNavigation() {
  const { orgUuid } = useParams<{ orgUuid: string }>();
  const { pathname } = useLocation();

  return (
    <Sidebar variant="inset" data-testid="sidebar-nav">
      <HeaderNav />

      <SidebarContent>
        <MainNav orgUuid={orgUuid} pathname={pathname} />
        <SearchesNav orgUuid={orgUuid} pathname={pathname} />
        <TagsNav orgUuid={orgUuid} pathname={pathname} />
      </SidebarContent>

      <SidebarFooter>
        <FooterNav orgUuid={orgUuid} pathname={pathname} />
      </SidebarFooter>
    </Sidebar>
  );
}
